<template>
  <figure
    class="data__figure data__figure--chart chart-div"
    ref="chartDiv"
    :id="'chart-' + slug"
  ></figure>
</template>

<script setup>
import { ChartCreator, Snapshot } from "chesapeake-progress-charts";
import "chesapeake-progress-charts/dist/progress-charts.css";
import { computed, getCurrentInstance, onMounted, ref } from "vue";

const defaultMargin = { top: 20, right: 5, bottom: 50, left: 65 };
const camera = new Snapshot();
const snapshotTarget = ref(null);

//template refs
const chartDiv = ref(null);

const props = defineProps({
  srcUrl: {
    type: String,
    default: null,
  },
  slug: {
    type: String,
  },
  margin: {
    default: () => ({}),
    type: Object,
  },
  width: {
    default: "",
    type: String,
  },
  height: {
    default: "",
    type: String,
  },
  dataObj: {
    default: () => ({}),
    type: Object,
  },
});

//lifecycle
onMounted(() => {
  const instance = getCurrentInstance();
  snapshotTarget.value = instance.root.refs.chartApp;
  const chartData = {
    url: props.srcUrl,
    data: props.dataObj,
  };
  if (Object.keys(props.dataObj).length === 0) delete chartData.data;
  const chartOptions = {
    data: chartData,
    margin: mergedMargin.value,
    width: props.width,
    height: props.height,
  };
  if (props.width === "") delete chartOptions.width;
  if (props.height === "") delete chartOptions.height;
  new ChartCreator(chartDiv.value, chartOptions);
});

//computed
const mergedMargin = computed(() => {
  return {
    ...defaultMargin,
    ...props.margin,
  };
});

//methods
const snapshot = async function () {
  const options = {
    allowTaint: true,
    useCORS: true,
    logging: false,
  };

  await camera.snap(snapshotTarget.value, props.slug, options);
};
defineExpose({ snapshot });
</script>

<style lang="scss" scoped>
.chart-div {
  width: 1051px;
}
</style>
<style lang="scss">
.scatterplot-chart .axis .tick foreignObject span {
  font-size: var(--axisLabelSize);
}
.scatterplot-chart {
  --axisLabelSize: 1.3em;
}
</style>
